import { isOrganisationsResponse } from "@app/components/organisation/types";
import API from "@app/services/api";
import { refreshUser } from "@app/utils/use-most-fresh-user";

/**
 * Work in ``organisationId``, or in none (PT-119), then reload.
 *
 * Reloaded rather than re-rendered: inside an industriel the role itself changes, and every screen
 * already open read with the previous one.
 */
export async function workIn(organisationId: string | null): Promise<unknown> {
  const res: unknown = organisationId
    ? await API.post({ path: `/organisation/${organisationId}/activate` })
    : await API.post({ path: "/organisation/deactivate" });
  if (isOrganisationsResponse(res)) {
    await refreshUser("organisation-context");
    window.location.reload();
  }
  return res;
}
